<template>
  <div class="table">
    <div class="container">
      <!--=========查询模块================-->
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.roleList.roleNo')" prop="roleNo">
                <el-input v-model="queryCondition.roleNo" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.roleList.roleCN')" prop="roleNameCn">
                <el-input v-model="queryCondition.roleNameCn" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.roleList.roleEN')" prop="roleNameEn">
                <el-input v-model="queryCondition.roleNameEn" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>

      <el-row class="action-btn-row">
        <el-button type="primary" v-acl="RoleNew" @click="showRoleDialog('add')">{{$t('common.addNew')}}</el-button>
        <el-button type="danger" v-acl="RoleDeleteRole" @click="delSelRole">{{$t('common.del')}}</el-button>
      </el-row>
      <!--=========查询模块END================-->
      <!--=========角色数据列表================-->
      <el-table sortable max-height="435" :data="roleList" ref="roleDataTable" border highlight-current-row class="table">
        <el-table-column align="center" sortable prop="tmRoleId" type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roleNo" :label="$t('sys.roleList.roleNo')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roleNameCn" :label="$t('sys.roleList.roleCN')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roleNameEn" :label="$t('sys.roleList.roleEN')"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button type="primary" v-acl="RoleEdit" size="mini" @click="showRoleDialog('update',scope.row,scope.$index)">{{$t('common.edit')}}</el-button>
            <el-button v-acl="RoleFunction" @click.native.prevent="roleFunctionShow(scope.row.tmRoleId)" type="primary" size="mini">
              {{$t('sys.roleList.roleSet')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========角色数据列表END================-->
    <!--=========角色信息编辑================-->
    <el-dialog :title="$t('sys.roleList.roleInfo')" :visible.sync="roleDialog" width="600px">
      <el-form :model="roleInfo" ref="roleInfoForm" class="form_border" :rules="roleRules" :label-position="labelPosition" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="16">
            <el-form-item :label="$t('sys.roleList.roleNo')" placeholder="" prop="roleNo">
              <el-input v-model="roleInfo.roleNo" />
            </el-form-item>

            <el-form-item :label="$t('sys.roleList.roleCN')" placeholder="" prop="roleNameCn">
              <el-input v-model="roleInfo.roleNameCn" />
            </el-form-item>

            <el-form-item :label="$t('sys.roleList.roleEN')" placeholder="" prop="roleNameEn">
              <el-input v-model="roleInfo.roleNameEn" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="roleDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" @click="saveOrUpdateRole">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========角色信息编辑END================-->
    <!--=========角色权限选择================-->
    <el-dialog :title="$t('sys.roleList.roleFunction')" :visible.sync="roleFunctionDialogVisible" width="630px">
      <el-tree ref="roleFunctionTree" :data="treeDate" show-checkbox node-key="id" :check-strictly="true" :default-expanded-keys="openNodes" :default-checked-keys="checkedKeys" @check-change="treeCheckChange" :props="{children: 'children', label: 'label' }">
      </el-tree>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="roleFunctionDialogVisible = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" v-acl="RoleSaveFunction" @click="saveRoleFunction">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========角色权限选择END================-->
  </div>
</template>
<script>
import { roleService } from "../../../api/user-manage/role";
import { Message } from "element-ui";
import commonFunction from "../../../utils/dataTableUtils"
import commonFun from "@/utils/commonFun";
export default {
  name: 'role-manage',
  data() {
    return {
      method: "",
      roleIds: [],
      roleList: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: { pageSize: 15, pageNum: 1, roleNo: "", roleNameCn: "", roleNameEn: "" },
      roleDialog: false,
      roleInfo: {},
      roleRules: {
        roleNo: [
          { required: true, message: this.$t('sys.roleList.inputRoleNo'), trigger: 'blur' }
        ],
        roleNameCn: [
          { required: true, message: this.$t('sys.roleList.inputRoleCN'), trigger: 'blur' }
        ]
      },

      roleFunctionDialogVisible: false,
      treeDate: [],
      checkedKeys: [],
      openNodes: [],
      roleId: null,
    }
  },
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      roleService.getRoleData(this.queryCondition).then((res) => {
        this.roleList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //删除用户信息方法
    delSelRole() {
      let rows = this.$refs.roleDataTable.selection;
      if (rows.length == 0) {
        Message({ message: this.$t('sys.roleList.selectDelRole'), type: "warning" });
      } else {
        this.roleIds = [];
        rows.forEach((item) => {
          this.roleIds.push(item.tmRoleId)
        });

        this.$confirm(this.$t('common.delWarning'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          roleService.deleteRole(this.roleIds).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }).catch(() => {

        });
      }
    },
    showRoleDialog(method, row, index) {
      this.clearVlidate("roleInfoForm");
      this.method = method;
      this.roleInfo = {};
      if ('update' === method) {
        //将选种的传给roleInfo
        this.roleInfo = row;
      }
      this.roleDialog = true;
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    //创建用户信息方法
    saveOrUpdateRole() {
      let validFlag = false;
      this.$refs['roleInfoForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      roleService.saveOrUpdateRole(this.roleInfo, this.method).then((res) => {
        if (res.meta.success) {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.roleDialog = false;
          this.queryData();

        } else {
          Message({ message: res.meta.msg, type: "error" });
          this.queryData();
        }
      });
    },
    roleFunctionShow(roleId) {
      this.checkedKeys = [];
      this.openNodes = [];
      this.treeDate = [];
      roleService.getFunctionTreeData(roleId).then((res) => {
        if (res.meta.success) {
          this.roleid = roleId;
          this.treeDate = res.data.treeData;
          this.checkedKeys = res.data.hasRoleId;
          this.openNodes = res.data.openNode;
          this.roleFunctionDialogVisible = true;
        }
      });
    },
    treeCheckChange(node, checked, childChecked) {
      const result = [];
      // this.$refs.roleFunctionTree.setChecked(node.id, checked, true);
      const loop = tmp => {
        result.push(tmp.id);
        if (commonFun.isNotEmpty(tmp.children)) {
          tmp.children.forEach(loop);
        }
      };

      if (commonFun.isNotEmpty(node.children)) {
        node.children.forEach(loop);
      }

      result.forEach(value => {
        this.$refs.roleFunctionTree.setChecked(value, checked);
      })
    },
    getChildrenIds(node) {
      return [node.id];
      if (commonFun.isNotEmpty(node.children)) {
        for (let i = 0; i < node.children.length; i++) {
          return node.idnode.children[i].id
        }
      }
    },
    saveRoleFunction() {
      let checkedFunction = this.$refs.roleFunctionTree.getCheckedKeys();
      roleService.saveFunctionTreeData(this.roleid, checkedFunction).then((res) => {
        if (res.meta.success) {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
        }
      });

    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.form_header {
  text-align: center;
  margin-bottom: 10px;
}
</style>
